export const formatPercentageAsString = (percentage: number): string =>
  `${percentage}%`;
